import { getParam } from "./query";

// If we have a ?some_entity=id in the URL, we want to scroll to the first element
// with data-some-entity=id.
export function maybeScrollTo(name) {
  const id = getParam(name);
  if (!id) {
    return;
  }

  const target = document.querySelector(`[data-${name.replaceAll("_", "-")}="${CSS.escape(id)}"]`);
  target?.scrollIntoView({ behavior: "smooth" });

  // We may be tempted to remove the query parameter from the URL after
  // scrolling to the element. I've chosen not to do that, because in some
  // cases this might actually be useful. If we get enough feedback that this
  // is not the case, we can always add a parameter to this function to control
  // it depending on the use case.
  // For example, customer_id on the customers page has never been cleared before.
}
